import { Box, styled } from '@mui/material';
export const EventBatch = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    '&:not(:last-child)': {
        borderBottom: '1px solid #B1B1B1',
    },
    borderRadius: 4,
}));
